import { PayloadAction } from '@reduxjs/toolkit';
import { QueryClient } from '@tanstack/react-query';
import { getContext, takeLatest } from 'redux-saga/effects';
import { sagaTaskDescriptor } from 'data';
import { setQueryClientAction } from '../actions';

export const getQueryClientContext = function* () {
  return yield getContext('queryClient');
};

function setQueryClientContext({ payload }: PayloadAction<QueryClient>) {
  sagaTaskDescriptor.setContext({
    queryClient: payload,
  });
}

export const watchQueryClientSaga = function* (): Generator {
  yield takeLatest(setQueryClientAction.type, setQueryClientContext);
};
